export default "__VITE_ASSET__109e3cd1__"